import React from 'react';

function Footer() {
  const footerPhrases = [
    "What do people put in website footers nowadays?",
    "Footer? I hardly know 'er!",
    "© 2026 by Dalmo",
    "Made with ❤️",
    "Need a footer? Call Dalmo."
  ];

  const randomPhrase = footerPhrases[Math.floor(Math.random() * footerPhrases.length)];

  return (
    <footer className="bg-black text-white p-2 text-center bottom-0 w-full">
      {randomPhrase}
    </footer>
  );
}

export default Footer;
